import GenericSelectMenu from "../../../GenericSelectMenu";
import StepsContainer from "../../../container";
import Info from "../../../Info";
import { useRequalifyReportMachine } from "../../../../../context/RequalifyReportMachineContext";
import { Trans, useTranslation } from "react-i18next";
import Summary from "./Summary";

export default function Step2() {
  const [requalifyReportState, requalifyReportSend] =
    useRequalifyReportMachine();
  const { t } = useTranslation();

  return (
    <StepsContainer>
      {requalifyReportState.context?.changeSet?.consequence.forced_severity ? (
        <div>
          <Info>
            <Trans
              i18nKey="requalifyEvent.steps.step2.form.info"
              components={{ span: <span className="font-semibold" /> }}
            />
          </Info>
        </div>
      ) : null}
      <div>
        <GenericSelectMenu
          data={requalifyReportState.context?.severityTypes}
          selectedItem={requalifyReportState.context?.changeSet?.severity}
          noSelectionText={t(
            "requalifyEvent.steps.step2.form.placeholder.severity",
          )}
          onItemSelected={(element) => {
            requalifyReportSend({
              type: "SEVERITY_SELECTED",
              data: element,
            });
          }}
          label={t("requalifyEvent.steps.step2.form.label.severity")}
          useNameForKey={true}
          useEntireItemForValue={true}
          disabled={
            requalifyReportState.context?.changeSet?.consequence.forced_severity
              ? true
              : false
          }
          i18nPrefixKey="shared.type.severity."
        />
      </div>
      <div>
        <GenericSelectMenu
          data={requalifyReportState.context?.probabilityTypes}
          selectedItem={requalifyReportState.context?.changeSet?.probability}
          noSelectionText={t(
            "requalifyEvent.steps.step2.form.placeholder.probability",
          )}
          onItemSelected={(element) => {
            requalifyReportSend({
              type: "PROBABILITY_SELECTED",
              data: element,
            });
          }}
          label={t("requalifyEvent.steps.step2.form.label.probability")}
          useNameForKey={true}
          useEntireItemForValue={true}
          disabled={
            requalifyReportState.context?.changeSet?.consequence.forced_severity
              ? true
              : false
          }
          i18nPrefixKey="shared.type.probability."
        />
      </div>
      {requalifyReportState.context?.changeSet?.criticity && (
        <div className="pt-6">
          <Summary />
        </div>
      )}
    </StepsContainer>
  );
}
